import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You'll notice that one of the parameters in the `}<inlineCode parentName="p">{`identify`}</inlineCode>{` method is a `}<inlineCode parentName="p">{`properties`}</inlineCode>{` object. This enables you to set `}<a parentName="p" {...{
        "href": "/docs/getting-started/user-properties"
      }}>{`user properties`}</a>{`. Whenever possible, we recommend passing in all user properties you have available each time you call identify, as this ensures their user profile on PostHog is up to date.`}</p>
    <p>{`User properties can also be set using a `}<inlineCode parentName="p">{`capture`}</inlineCode>{` and not only with `}<inlineCode parentName="p">{`identify`}</inlineCode>{`. See our `}<a parentName="p" {...{
        "href": "/docs/getting-started/user-properties"
      }}>{`user properties docs`}</a>{` for more details on how to work with them and best practices.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      